<div class="side-by-eaches" *ngIf="integration?.id">
    <div class="side-by-eaches-temp-input">
        <input name="mailchimp-list-id" type="text" [(ngModel)]="integration.options.listId" placeholder="List ID" />
    </div>
    <div class="side-by-eaches-temp-action">
        <app-button (action)="updated.emit(integration)" [busy]="busy">Set</app-button>
    </div>
</div>
